import React from 'react';
import Icon from '@guestyci/foundation/next/Icon';
import { ReactComponent as LogoSvg } from '../../assets/guesty-logo.svg';

const Logo = () => <Icon svg={LogoSvg} width={120} height={40} />;

export default Logo;
